import { useEffect, useRef, useState } from "react";

export function useSubmitLock(processing = false) {
  const lockedRef = useRef(false);
  const mountedRef = useRef(true);
  const [locked, setLocked] = useState(false);

  useEffect(() => () => {
    mountedRef.current = false;
  }, []);

  const startSubmit = () => {
    if (processing || lockedRef.current) return false;

    lockedRef.current = true;
    if (mountedRef.current) setLocked(true);
    return true;
  };

  const finishSubmit = () => {
    lockedRef.current = false;
    if (mountedRef.current) setLocked(false);
  };

  return {
    submitting: processing || locked,
    startSubmit,
    finishSubmit,
  };
}
